import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import $ from 'jquery';
import _ from 'underscore';

import { faPause, faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import "video.js/dist/video-js.css";

import FadeLoader from 'react-spinners/FadeLoader';

export default function VideoClip(props){

    const videoRef = useRef(null);

    var currentPlayingTime = 0;
    var durationTime = 0;

    useEffect(() => {
        startTime();
    },[props.frontTime]);

    const startTime = () => {
        videoRef.current.seekTo(props.frontTime);
        props.setLoading(false);
        props.setPlaying(true);
    }

    const videoProgress = (param) => {
        var playingType = props.getPlayingType();

        if(playingType !== 'justplay'){
			//만약 재생방법이 3이 아니라면 영상 재생시간동안 재생한 후 멈췄다가 다음 동작 진행 
            if(param.playedSeconds > props.frontTime+props.duration){
                //setPlaying(false);
                restartByTypeHandler(playingType);
            }
		} else if (playingType === 'justplay'){
            //만약 재생 방법이 3이라면 그냥 쭉 재생! (대신 스타일은 적용 필요)
            var currentKey = props.dataKey;
            var playList = props.playList;

            let newKey = 0;
            let currentKeyIdx = 0;

            playList.forEach(function(item,idx){
                newKey = item.gameInfoId+''+item.gameRecordId+''+item.inning+''+item.inningTb+''+item.batInningTurn+''+item.batPitchSeq;

                if(newKey == currentKey){
                    currentKeyIdx = idx;
                }
            });

            var nextKeyIdx = currentKeyIdx + 1;
            var lastIdx = _.size(playList)-1;

            //만약 다음 영상이 있다면 
            if(nextKeyIdx <= lastIdx){
                let nextKey = 0;

                playList.forEach(function(item,idx){
                    newKey = item.gameInfoId+''+item.gameRecordId+''+item.inning+''+item.inningTb+''+item.batInningTurn+''+item.batPitchSeq;
        
                    if(idx == nextKeyIdx){
                        nextKey = newKey;
                    }
                });

                var findPitch = playList.find(function(pitch){
                    return nextKey === pitch.gameInfoId+''+pitch.gameRecordId+''+pitch.inning+''+pitch.inningTb+''+pitch.batInningTurn+''+pitch.batPitchSeq;
                });

                var startTime = findPitch.pitchTime - findPitch.taggingGapTime;
    
                var result = settingJustPlay(startTime, findPitch, param.playedSeconds);
    
                //영상이 넘어가는 순간
                if(result == true){
                    $("[name='videoClips']").removeClass('active');
                    //$("[name='videoClips']").css("backgroundColor","");
                    props.setDataKey(nextKey);
                    props.setFrontTime(currentPlayingTime);
                    props.setDuration(durationTime);
                    
                    props.setCaptionState(true);

                    //자막 텍스트 생성
                    var videoText = props.trackTextMake(findPitch);
                    $("#videoTextArea").html(videoText);
                }
            } else {
                //만약 다음 영상이 없다면 
                // if(param.playedSeconds > props.frontTime+props.duration){
                //     props.setPlaying(false);
                //     $("[name='videoClips']").css("backgroundColor","");
                //     if(props.useLang === "en"){
                //         alert("Video playback is complete");
                //     } else {
                //         alert("영상 재생이 완료되었습니다.");
                //     }
                // }
            }

        }

    }

    const settingJustPlay = (startTime, pitchInfo, playedSeconds) => {
        //영상의 시작시간(frontTime)과 재생시간(duration) 설정
        var checkBase = pitchInfo.checkBase;
        var hitResultCode = pitchInfo.hitResultCode;
        var beforeOutCount = pitchInfo.beforeOutCount;
        var beforeRunnerState = pitchInfo.beforeRunnerState;
        var outCount = pitchInfo.outCount;
        
        var forStaff = $("#forStaff").is(":checked");
        var f_Time = 2;
        durationTime = 7;
        
        if (typeof(checkBase) != 'undefined' && (checkBase != '0' || checkBase != 0 )) {
            f_Time = 5;
            durationTime = 10;
        }
        
        if (typeof (hitResultCode) != 'undefined' && (hitResultCode != '0' || hitResultCode != 0)) {
            f_Time = 2;
            durationTime = 10;
            if (beforeOutCount != outCount) {
				//타격 결과가 있고 아웃카운트에 변동이 있을 경우 frontTime = 2 & duration = 17
				//d_Time = 17;
                durationTime = 17;
			}
        }

        if(forStaff && (beforeRunnerState != 0 || beforeRunnerState!= '0')) {
            f_Time = 7;
            durationTime = 17;
        }
        
        currentPlayingTime = startTime - f_Time;

        if(playedSeconds > props.frontTime + props.duration){
            props.setCaptionState(false);
        }

        //스타일이 옮겨지는 타이밍이 조금 늦는 느낌이라 시간에서 -1을 해줌
        if(playedSeconds > currentPlayingTime - 1){
            return true;
        }
    }

    const restartByTypeHandler = (playingType) => {
        if(playingType === 'repeat'){
            startTime();
        } else if(playingType === 'sequence'){ 
            playNextClipHandler();
        }
	}

    const playNextClipHandler = () => {
        //다음 영상 재생 이벤트 핸들러
        var currentKey = props.dataKey;
        var playList = props.playList;

        $("[name='videoClips']").removeClass('active');
        //$("[name='videoClips']").css("backgroundColor","");

        let newKey = 0;
        let currentKeyIdx = 0;

        playList.forEach(function(item,idx){
            newKey = item.gameInfoId+''+item.gameRecordId+''+item.inning+''+item.inningTb+''+item.batInningTurn+''+item.batPitchSeq;

            if(newKey == currentKey){
                currentKeyIdx = idx;
            }
        });

        var nextKeyIdx = currentKeyIdx + 1;
		var lastIdx = _.size(playList)-1;

        if(nextKeyIdx <= lastIdx){
            //다음으로 재생할 영상이 있는 경우
            let nextKey = 0;

            playList.forEach(function(item,idx){
                newKey = item.gameInfoId+''+item.gameRecordId+''+item.inning+''+item.inningTb+''+item.batInningTurn+''+item.batPitchSeq;
    
                if(idx == nextKeyIdx){
                    nextKey = newKey;
                }
            });

            var findPitch = playList.find(function(pitch){
				return nextKey === pitch.gameInfoId+''+pitch.gameRecordId+''+pitch.inning+''+pitch.inningTb+''+pitch.batInningTurn+''+pitch.batPitchSeq;
			})

            var selectedVideoPath = findPitch.videoPath;
            var selectedGoogleVideoPath = findPitch.googleVideoPath;
            var startTime = findPitch.pitchTime - findPitch.taggingGapTime;

            var mp4VideoPath = selectedVideoPath.replace("/mp4hls/index.m3u8"," ");

            props.setDataKey(nextKey);
            //VideoScreen으로 넘겨줄 src 값을 set 해준다.
            props.setPath(selectedGoogleVideoPath);
            props.setAnotherPath(mp4VideoPath);

            props.settingClipPlay(startTime, findPitch);
            

        } else {
            //현재 재생중인 영상이 마지막 영상일 경우
            if(props.useLang === "en"){
                alert("Video list playback is complete");
            } else {
                alert('리스트 재생이 완료되었습니다.');
            }
            props.setPlaying(false);

        }

    }

    //영상 재생 화면 클릭 이벤트 핸들러(재생/일시정지 설정)
    const screenHandler = (evt) => {        
        if(typeof props.dataKey == 'undefined' || props.dataKey == ''){
            //영상을 선택하지 않은 상태라면
            if(props.useLang === "en"){
                alert("Please select a video first");
            } else {
                alert("재생할 영상을 선택해주세요");
            }
        } else {
            //화면을 클릭했을 때 살짝 어두워지는 효과            
            $(evt.currentTarget).animate({opacity:0.5}, 300);
            $('#playIcon').animate({opacity:0.8}, 300);

            if(props.playing === true){
                //만약 영상이 재생중이라면
                props.setPlaying(false);
                props.setIcon(faPause);
            } else if(props.playing === false){
                //만약 영상이 일시정지 상태라면
                props.setPlaying(true);
                props.setIcon(faPlay);
                $(evt.currentTarget).animate({opacity:0}, 300);
                $('#playIcon').animate({opacity:0}, 300);
            } 
        }
	}

    //영상 재생이 되지 않을 때 videoPath를 다시 지정해주는 함수
    const videoLoadingError = () => {
        var arr = props.path.split('.')[0];
        
        //조건문 이용하여 분기
        //1. 만약 path가 http://hanwha_media.storage.googleapis.com이라면 
        //(m.movie로 다시 setPath 해주기)
        //2. 만약 path가 http://m.movie.kbostats.net이라면
        //(movie로 다시 setPath 해주기 --> 참고로 이 값은 그냥 findPitch.videoPath임)

        if(arr === "http://hanwha_media"){
            //1.
            var mSrc = props.anotherPath.replace('movie', 'm.movie');
            props.setPath(mSrc);
        } else if(arr === "http://m"){
            //2.
            props.setPath(props.anotherPath);
        }
        
    }


    return(
        <div style={{position:"relative",display:"flex", justifyContent:"center", alignItems:"center"}}> 
            <div id="videoTextDiv" style={{position:"absolute", display:"flex", justifyContent:"center", backgroundColor:"rgba(0, 0, 0, 0.7)", width:"100%", height:"30px", top:"80%"}}>
                <span id="videoTextArea" style={{ zIndex:"1", opacity:"0", color:"#FFF", textAlign:"center", fontSize:"15px", padding:"4px 0px"}}></span>
            </div>
            <div id='screenController' onClick={screenHandler} className="video-js vjs-16-9" style={{position:"absolute", zIndex:"2", opacity:"0", top:"0"}}>
            </div>
            <FontAwesomeIcon id="playIcon" icon={props.icon} style={{position:"absolute", fontSize:"100px", color:"#FFF", zIndex:"3", opacity:"0"}}></FontAwesomeIcon>
            <div style={{position:"absolute"}}>
                {props.loading ? <FadeLoader color="#FFFFFF" height={15} width={5} radius={2} margin={2}/> : null}                
            </div>
            <div className="player-wrapper" style={{width:"100%"}}>
                <ReactPlayer
                    ref={videoRef}
                    className='react-player'
                    url={props.path}
                    playing={props.playing}
                    muted={true}
                    loop={false}
                    config={{
                        file:{
                            attributes:{
                                poster:"https://blog.kakaocdn.net/dn/Wddvk/btqAqhHHM3k/6hAu4NLbmUqKfR2SVJ4bM1/img.png"
                            }
                        }
                    }}
                    onStart={startTime}
                    onProgress={videoProgress}
                    onError={videoLoadingError}
                    width="100%"
                    height=""
                    playsinline
                ></ReactPlayer>
            </div>
        </div>
    )
}

